export const INBOX_STATUS = {
  UNREAD: 0,
  READ: 1,
};

export const INBOX_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(INBOX_STATUS.UNREAD), label: '未讀' },
  { value: String(INBOX_STATUS.READ), label: '已讀' },
];

export const INBOX_FORM_STATUS_OPTIONS = [
  { value: INBOX_STATUS.UNREAD, label: '未讀' },
  { value: INBOX_STATUS.READ, label: '已讀' },
];

export const BROADCAST_SEND_TYPE = {
  ALL: 0,
  SPECIFIC: 1,
  AGENT: 2,
};

export const BROADCAST_SEND_TYPE_OPTIONS = [
  { value: BROADCAST_SEND_TYPE.ALL, label: '所有用戶' },
  { value: BROADCAST_SEND_TYPE.SPECIFIC, label: '特定名單' },
  { value: BROADCAST_SEND_TYPE.AGENT, label: '團隊代理' },
];

export const SITE_MESSAGE_PAGE_SIZE = 20;
export const EN_LANG_CODE = 'en_US';

export function buildInboxPageParams(pageNo, filters = {}, pageSize = SITE_MESSAGE_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.status !== '' && filters.status != null) {
    params.status = Number(filters.status);
  }
  if (filters.memberId?.trim()) {
    params.memberId = Number(filters.memberId.trim());
  }
  if (filters.title?.trim()) {
    params.title = filters.title.trim();
  }
  return params;
}

export function buildBroadcastPageParams(pageNo, filters = {}, pageSize = SITE_MESSAGE_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.title?.trim()) {
    params.title = filters.title.trim();
  }
  return params;
}

export function formatInboxStatus(status) {
  return status === INBOX_STATUS.READ ? '已讀' : '未讀';
}

export function formatBroadcastSendType(sendType) {
  const found = BROADCAST_SEND_TYPE_OPTIONS.find((item) => item.value === sendType);
  return found?.label || '—';
}

export function emptyInboxDetail(lang) {
  return { lang, title: '', body: '' };
}

export function mergeInboxDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({ code, label: lang.label || code });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({ code: item.lang, label: item.lang });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyInboxDetail(code), _label: label };
  });
}

export function stripInboxDetails(details) {
  return (details || []).map(({ lang, title, body }) => ({
    lang,
    title: title || '',
    body: body || '',
  }));
}

export function parseIdList(value) {
  if (!value?.trim()) {
    return [];
  }
  return value
    .split(/[,，\s]+/)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => Number(part))
    .filter((num) => Number.isFinite(num) && num > 0);
}

export function formatIdList(ids) {
  if (!ids?.length) {
    return '';
  }
  return ids.join(', ');
}
